import { c as _c } from "react/compiler-runtime";
import clsx from "classnames";
import React from "react";
import { usePageProps } from "common/hooks/data/usePageProps";
import type { AppProps } from "common/lib/getAppServerSideProps";
import { useTranslations } from "modules/i18n/hooks/useTranslations";
import { pageUrl } from "common/lib/router";
import { useRegionConfig } from "modules/i18n/hooks/useRegionConfig";
export const NavItems = () => {
  "use memo";

  const $ = _c(22);
  const {
    navItems,
    pageSlug,
    regionCode
  } = usePageProps();
  const t = useTranslations("layout.header");
  let t0;
  if ($[0] !== pageSlug || $[1] !== regionCode) {
    t0 = pageUrl.view({
      regionCode,
      pageSlug
    });
    $[0] = pageSlug;
    $[1] = regionCode;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const currentPathname = t0;
  const regionConfig = useRegionConfig();
  const {
    section_nav: t1
  } = regionConfig;
  const {
    custom_nav_link: customNavLink
  } = t1;
  const t2 = `/${regionCode}/home-page`;
  let t3;
  if ($[3] !== t) {
    t3 = t("home");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = {
      path: t2,
      title: t3
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== navItems || $[9] !== t4) {
    t5 = [t4, ...navItems];
    $[8] = navItems;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const navItemsWithHome = t5;
  let t6;
  if ($[11] !== currentPathname || $[12] !== navItemsWithHome) {
    t6 = navItemsWithHome.map(t7 => {
      const {
        path,
        title
      } = t7;
      return <a key={path} href={path} className={clsx("my-1.5 border-l-8 py-0.5 pl-2 -outline-offset-1 hover:underline", {
        "border-gray-700": currentPathname === path,
        "border-white": currentPathname !== path
      })} role="menuitem">{title}</a>;
    });
    $[11] = currentPathname;
    $[12] = navItemsWithHome;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== currentPathname || $[15] !== customNavLink.enabled || $[16] !== customNavLink.link || $[17] !== customNavLink.title) {
    t7 = customNavLink.enabled && <a href={customNavLink.link} className={clsx("my-1.5 border-l-8 py-0.5 pl-2 -outline-offset-1 hover:underline", {
      "border-gray-700": currentPathname === customNavLink.link,
      "border-white": currentPathname !== customNavLink.link
    })} role="menuitem">{customNavLink.title}</a>;
    $[14] = currentPathname;
    $[15] = customNavLink.enabled;
    $[16] = customNavLink.link;
    $[17] = customNavLink.title;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = <div className="font-sans-heading my-3 mb-8 flex flex-col text-xl font-bold" role="menu" aria-orientation="vertical">{t6}{t7}</div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};